var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      directives: [
        {
          name: "loading",
          rawName: "v-loading.body",
          value: _vm.loading,
          expression: "loading",
          modifiers: { body: true }
        }
      ]
    },
    [
      _c(
        "el-row",
        { staticClass: "filter" },
        [
          _c(
            "el-col",
            [
              _c(
                "div",
                {
                  staticStyle: {
                    background: "#f3f3f3",
                    height: "30px",
                    "line-height": "30px",
                    padding: "0 25px",
                    display: "flex",
                    "align-items": "center"
                  }
                },
                [
                  _c("div", [_vm._v("查询搜索")]),
                  _vm._v(" "),
                  _c(
                    "el-button",
                    {
                      staticStyle: { "margin-left": "auto" },
                      attrs: {
                        type: "text",
                        icon: _vm.filterFold
                          ? "el-icon-arrow-down"
                          : "el-icon-arrow-up"
                      },
                      on: { click: _vm.toggleFilter }
                    },
                    [
                      _vm._v(
                        "\n          " +
                          _vm._s(_vm.filterFold ? "展开筛选" : "收起筛选") +
                          "\n        "
                      )
                    ]
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c("el-collapse-transition", [
                _c(
                  "div",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: !_vm.filterFold,
                        expression: "!filterFold"
                      }
                    ]
                  },
                  [
                    _c(
                      "div",
                      { staticStyle: { padding: "10px 25px" } },
                      [
                        _c(
                          "el-form",
                          {
                            ref: "form",
                            attrs: { model: _vm.form, "label-width": "85px" }
                          },
                          [
                            _c(
                              "el-row",
                              { attrs: { gutter: 10 } },
                              [
                                _c(
                                  "el-col",
                                  [
                                    _c(
                                      "el-form-item",
                                      { attrs: { label: "输入搜索：" } },
                                      [
                                        _c(
                                          "el-col",
                                          { attrs: { span: 2 } },
                                          [
                                            _c("el-input", {
                                              attrs: {
                                                placeholder: "客服工单id"
                                              },
                                              nativeOn: {
                                                keyup: function($event) {
                                                  if (
                                                    !$event.type.indexOf(
                                                      "key"
                                                    ) &&
                                                    _vm._k(
                                                      $event.keyCode,
                                                      "enter",
                                                      13,
                                                      $event.key,
                                                      "Enter"
                                                    )
                                                  ) {
                                                    return null
                                                  }
                                                  return _vm.search.apply(
                                                    null,
                                                    arguments
                                                  )
                                                }
                                              },
                                              model: {
                                                value: _vm.form.work_order_id,
                                                callback: function($$v) {
                                                  _vm.$set(
                                                    _vm.form,
                                                    "work_order_id",
                                                    $$v
                                                  )
                                                },
                                                expression: "form.work_order_id"
                                              }
                                            })
                                          ],
                                          1
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "el-col",
                                          { attrs: { span: 2 } },
                                          [
                                            _c("el-input", {
                                              attrs: { placeholder: "用户id" },
                                              nativeOn: {
                                                keyup: function($event) {
                                                  if (
                                                    !$event.type.indexOf(
                                                      "key"
                                                    ) &&
                                                    _vm._k(
                                                      $event.keyCode,
                                                      "enter",
                                                      13,
                                                      $event.key,
                                                      "Enter"
                                                    )
                                                  ) {
                                                    return null
                                                  }
                                                  return _vm.search.apply(
                                                    null,
                                                    arguments
                                                  )
                                                }
                                              },
                                              model: {
                                                value: _vm.form.user_id,
                                                callback: function($$v) {
                                                  _vm.$set(
                                                    _vm.form,
                                                    "user_id",
                                                    $$v
                                                  )
                                                },
                                                expression: "form.user_id"
                                              }
                                            })
                                          ],
                                          1
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "el-col",
                                          { attrs: { span: 3 } },
                                          [
                                            _c(
                                              "el-select",
                                              {
                                                attrs: {
                                                  placeholder: "无数据类型"
                                                },
                                                model: {
                                                  value: _vm.form.type,
                                                  callback: function($$v) {
                                                    _vm.$set(
                                                      _vm.form,
                                                      "type",
                                                      $$v
                                                    )
                                                  },
                                                  expression: "form.type"
                                                }
                                              },
                                              [
                                                _c("el-option", {
                                                  attrs: {
                                                    value: "0",
                                                    label: "全部"
                                                  }
                                                }),
                                                _vm._v(" "),
                                                _c("el-option", {
                                                  attrs: {
                                                    value: "1",
                                                    label: "无信息"
                                                  }
                                                }),
                                                _vm._v(" "),
                                                _c("el-option", {
                                                  attrs: {
                                                    value: "2",
                                                    label: "无工单"
                                                  }
                                                }),
                                                _vm._v(" "),
                                                _c("el-option", {
                                                  attrs: {
                                                    value: "3",
                                                    label: "工单数据不一致"
                                                  }
                                                }),
                                                _vm._v(" "),
                                                _c("el-option", {
                                                  attrs: {
                                                    value: "4",
                                                    label: "疑似人为"
                                                  }
                                                })
                                              ],
                                              1
                                            )
                                          ],
                                          1
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "el-col",
                                          { attrs: { span: 2 } },
                                          [
                                            _c("el-input", {
                                              attrs: {
                                                placeholder: "商品货号"
                                              },
                                              nativeOn: {
                                                keyup: function($event) {
                                                  if (
                                                    !$event.type.indexOf(
                                                      "key"
                                                    ) &&
                                                    _vm._k(
                                                      $event.keyCode,
                                                      "enter",
                                                      13,
                                                      $event.key,
                                                      "Enter"
                                                    )
                                                  ) {
                                                    return null
                                                  }
                                                  return _vm.search.apply(
                                                    null,
                                                    arguments
                                                  )
                                                }
                                              },
                                              model: {
                                                value: _vm.form.goods_no,
                                                callback: function($$v) {
                                                  _vm.$set(
                                                    _vm.form,
                                                    "goods_no",
                                                    $$v
                                                  )
                                                },
                                                expression: "form.goods_no"
                                              }
                                            })
                                          ],
                                          1
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "el-col",
                                          { attrs: { span: 2 } },
                                          [
                                            _c("el-input", {
                                              attrs: {
                                                placeholder: "用户手机"
                                              },
                                              nativeOn: {
                                                keyup: function($event) {
                                                  if (
                                                    !$event.type.indexOf(
                                                      "key"
                                                    ) &&
                                                    _vm._k(
                                                      $event.keyCode,
                                                      "enter",
                                                      13,
                                                      $event.key,
                                                      "Enter"
                                                    )
                                                  ) {
                                                    return null
                                                  }
                                                  return _vm.search.apply(
                                                    null,
                                                    arguments
                                                  )
                                                }
                                              },
                                              model: {
                                                value: _vm.form.mobile,
                                                callback: function($$v) {
                                                  _vm.$set(
                                                    _vm.form,
                                                    "mobile",
                                                    $$v
                                                  )
                                                },
                                                expression: "form.mobile"
                                              }
                                            })
                                          ],
                                          1
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "el-col",
                                          { attrs: { span: 3 } },
                                          [
                                            _c("el-input", {
                                              attrs: {
                                                placeholder: "寄回运单号"
                                              },
                                              nativeOn: {
                                                keyup: function($event) {
                                                  if (
                                                    !$event.type.indexOf(
                                                      "key"
                                                    ) &&
                                                    _vm._k(
                                                      $event.keyCode,
                                                      "enter",
                                                      13,
                                                      $event.key,
                                                      "Enter"
                                                    )
                                                  ) {
                                                    return null
                                                  }
                                                  return _vm.search.apply(
                                                    null,
                                                    arguments
                                                  )
                                                }
                                              },
                                              model: {
                                                value: _vm.form.express_no,
                                                callback: function($$v) {
                                                  _vm.$set(
                                                    _vm.form,
                                                    "express_no",
                                                    $$v
                                                  )
                                                },
                                                expression: "form.express_no"
                                              }
                                            })
                                          ],
                                          1
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "el-col",
                                          { attrs: { span: 3 } },
                                          [
                                            _c("el-input", {
                                              attrs: { placeholder: "跟进人" },
                                              nativeOn: {
                                                keyup: function($event) {
                                                  if (
                                                    !$event.type.indexOf(
                                                      "key"
                                                    ) &&
                                                    _vm._k(
                                                      $event.keyCode,
                                                      "enter",
                                                      13,
                                                      $event.key,
                                                      "Enter"
                                                    )
                                                  ) {
                                                    return null
                                                  }
                                                  return _vm.search.apply(
                                                    null,
                                                    arguments
                                                  )
                                                }
                                              },
                                              model: {
                                                value: _vm.form.handle_admin,
                                                callback: function($$v) {
                                                  _vm.$set(
                                                    _vm.form,
                                                    "handle_admin",
                                                    $$v
                                                  )
                                                },
                                                expression: "form.handle_admin"
                                              }
                                            })
                                          ],
                                          1
                                        )
                                      ],
                                      1
                                    )
                                  ],
                                  1
                                )
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "el-row",
                              { attrs: { gutter: 10 } },
                              [
                                _c(
                                  "el-col",
                                  { attrs: { span: 7 } },
                                  [
                                    _c(
                                      "el-form-item",
                                      { attrs: { label: "拆包时间：" } },
                                      [
                                        _c("el-date-picker", {
                                          attrs: {
                                            type: "daterange",
                                            "value-format": "yyyy-MM-dd",
                                            "range-separator": "至",
                                            "start-placeholder": "开始日期",
                                            "end-placeholder": "结束日期"
                                          },
                                          model: {
                                            value: _vm.form.create_time,
                                            callback: function($$v) {
                                              _vm.$set(
                                                _vm.form,
                                                "create_time",
                                                $$v
                                              )
                                            },
                                            expression: "form.create_time"
                                          }
                                        })
                                      ],
                                      1
                                    )
                                  ],
                                  1
                                )
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "el-row",
                              { attrs: { gutter: 10 } },
                              [
                                _c(
                                  "el-col",
                                  { attrs: { span: 7 } },
                                  [
                                    _c(
                                      "el-form-item",
                                      { attrs: { label: "跟进时间：" } },
                                      [
                                        _c("el-date-picker", {
                                          attrs: {
                                            type: "daterange",
                                            "value-format": "yyyy-MM-dd",
                                            "range-separator": "至",
                                            "start-placeholder": "开始日期",
                                            "end-placeholder": "结束日期"
                                          },
                                          model: {
                                            value: _vm.form.handle_time,
                                            callback: function($$v) {
                                              _vm.$set(
                                                _vm.form,
                                                "handle_time",
                                                $$v
                                              )
                                            },
                                            expression: "form.handle_time"
                                          }
                                        })
                                      ],
                                      1
                                    )
                                  ],
                                  1
                                )
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "el-row",
                              { attrs: { gutter: 10 } },
                              [
                                _c(
                                  "el-col",
                                  { attrs: { span: 2 } },
                                  [
                                    _c(
                                      "el-button",
                                      {
                                        attrs: { type: "primary" },
                                        on: { click: _vm.search }
                                      },
                                      [_vm._v("查询")]
                                    )
                                  ],
                                  1
                                )
                              ],
                              1
                            )
                          ],
                          1
                        )
                      ],
                      1
                    )
                  ]
                )
              ])
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-row",
        [
          _c("el-col", { staticStyle: { border: "1px solid #ddd" } }, [
            _c(
              "div",
              {
                staticStyle: {
                  background: "#f3f3f3",
                  height: "50px",
                  "line-height": "30px",
                  padding: "0 25px",
                  display: "flex",
                  "align-items": "center"
                }
              },
              [
                _c("div", [_vm._v("数据列表：")]),
                _vm._v(" "),
                _c(
                  "el-button",
                  {
                    staticStyle: { "margin-left": "auto" },
                    attrs: { type: "success", size: "mini" },
                    on: { click: _vm.output }
                  },
                  [_vm._v("导出")]
                )
              ],
              1
            ),
            _vm._v(" "),
            _vm.resData
              ? _c(
                  "div",
                  { staticStyle: { "margin-bottom": "0" } },
                  [
                    _c(
                      "el-table",
                      {
                        directives: [
                          {
                            name: "loading",
                            rawName: "v-loading",
                            value: _vm.tableLoading,
                            expression: "tableLoading"
                          }
                        ],
                        ref: "multipleTable",
                        staticStyle: { width: "100%" },
                        attrs: {
                          height: "600",
                          data: _vm.resData.list,
                          "tooltip-effect": "dark"
                        },
                        on: { "selection-change": _vm.handleSelectionChange }
                      },
                      [
                        _c("el-table-column", {
                          attrs: {
                            prop: "create_time",
                            label: "拆包时间",
                            align: "center",
                            width: "100"
                          }
                        }),
                        _vm._v(" "),
                        _c("el-table-column", {
                          attrs: {
                            prop: "work_order_id",
                            label: "客服工单id",
                            align: "center",
                            width: "100"
                          }
                        }),
                        _vm._v(" "),
                        _c("el-table-column", {
                          attrs: {
                            prop: "no_data_work_type",
                            label: "无数据类型",
                            align: "center",
                            width: "100"
                          }
                        }),
                        _vm._v(" "),
                        _c("el-table-column", {
                          attrs: {
                            prop: "express_no",
                            label: "寄回运单号",
                            align: "center",
                            width: "100"
                          }
                        }),
                        _vm._v(" "),
                        _c("el-table-column", {
                          attrs: {
                            prop: "goods_img",
                            label: "商品图片",
                            align: "center",
                            width: "100"
                          },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "default",
                                fn: function(scope) {
                                  return [
                                    _c(
                                      "div",
                                      {
                                        staticStyle: {
                                          width: "70px",
                                          height: "70px"
                                        }
                                      },
                                      [
                                        _c("img", {
                                          staticStyle: {
                                            width: "100%",
                                            height: "100%"
                                          },
                                          attrs: { src: scope.row.goods_img },
                                          on: {
                                            click: function($event) {
                                              return _vm.showImages(
                                                scope.row.img
                                              )
                                            }
                                          }
                                        })
                                      ]
                                    )
                                  ]
                                }
                              }
                            ],
                            null,
                            false,
                            3169432409
                          )
                        }),
                        _vm._v(" "),
                        _c("el-table-column", {
                          attrs: {
                            prop: "goods_no",
                            label: "商品货号",
                            "show-overflow-tooltip": "",
                            align: "center"
                          }
                        }),
                        _vm._v(" "),
                        _c("el-table-column", {
                          attrs: {
                            prop: "mobile",
                            label: "用户手机",
                            "show-overflow-tooltip": "",
                            align: "center"
                          }
                        }),
                        _vm._v(" "),
                        _c("el-table-column", {
                          attrs: {
                            prop: "user_id",
                            label: "用户ID",
                            "show-overflow-tooltip": "",
                            align: "center"
                          }
                        }),
                        _vm._v(" "),
                        _c("el-table-column", {
                          attrs: {
                            prop: "goods_num",
                            label: "件数",
                            "show-overflow-tooltip": "",
                            align: "center"
                          }
                        }),
                        _vm._v(" "),
                        _c("el-table-column", {
                          attrs: {
                            prop: "space",
                            label: "仓位",
                            "show-overflow-tooltip": "",
                            align: "center"
                          }
                        }),
                        _vm._v(" "),
                        _c("el-table-column", {
                          attrs: {
                            prop: "reject_remark",
                            label: "售后备注",
                            "show-overflow-tooltip": "",
                            align: "center"
                          }
                        }),
                        _vm._v(" "),
                        _c("el-table-column", {
                          attrs: {
                            prop: "handle_admin",
                            label: "跟进人",
                            "show-overflow-tooltip": "",
                            align: "center"
                          }
                        }),
                        _vm._v(" "),
                        _c("el-table-column", {
                          attrs: {
                            prop: "handle_remark",
                            label: "跟进人备注",
                            "show-overflow-tooltip": "",
                            align: "center"
                          }
                        }),
                        _vm._v(" "),
                        _c("el-table-column", {
                          attrs: {
                            prop: "handle_time",
                            label: "跟进时间",
                            "show-overflow-tooltip": "",
                            align: "center"
                          }
                        }),
                        _vm._v(" "),
                        _c("el-table-column", {
                          attrs: {
                            prop: "handle_time",
                            label: "操作",
                            align: "center",
                            width: "100"
                          },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "default",
                                fn: function(scope) {
                                  return [
                                    _c(
                                      "el-button",
                                      {
                                        attrs: {
                                          size: "small",
                                          type: "primary"
                                        },
                                        on: {
                                          click: function($event) {
                                            return _vm.handleNoDataWork(
                                              scope.row.id
                                            )
                                          }
                                        }
                                      },
                                      [_vm._v("备注")]
                                    )
                                  ]
                                }
                              }
                            ],
                            null,
                            false,
                            3545956986
                          )
                        })
                      ],
                      1
                    )
                  ],
                  1
                )
              : _vm._e(),
            _vm._v(" "),
            _vm.resData
              ? _c(
                  "div",
                  { staticStyle: { "text-align": "right", padding: "25px" } },
                  [
                    _c("el-pagination", {
                      attrs: {
                        "current-page": _vm.curPage,
                        background: "",
                        layout: "total, prev, pager, next, jumper ",
                        total: _vm.resData.count,
                        "page-size": 10
                      },
                      on: {
                        "update:currentPage": function($event) {
                          _vm.curPage = $event
                        },
                        "update:current-page": function($event) {
                          _vm.curPage = $event
                        },
                        "current-change": _vm.handleCurrentChange
                      }
                    })
                  ],
                  1
                )
              : _vm._e()
          ])
        ],
        1
      ),
      _vm._v(" "),
      _c("preview-image", {
        attrs: { imgs: _vm.images, show: _vm.showbox },
        on: {
          closeBox: function($event) {
            return _vm.closeBox()
          }
        }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-7c738cf8", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7c738cf8","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/work/NoDataWorkList.vue
// module id = null
// module chunks = 